export default {
    BLUE_PERSON: 'blue-person',
    ORANGE_PERSON: 'orange-person',
    DANGLE: 'dangle/dangle',
    WALK_NEUTRAL: 'walk-neutral/walk-neutral',
    IDLE: 'idle',
};
